function o() {
  window.nostojs = window.nostojs ?? function(n) {
    (window.nostojs.q = window.nostojs.q ?? []).push(n);
  };
}
async function s(n) {
  return window.nostojs(n);
}
let t = null;
typeof window < "u" && (o(), s((n) => {
  t = n.internal.getSettings();
}));
function i() {
  return t;
}
function e(n) {
  t = n;
}
export {
  i as g,
  o as i,
  s as n,
  e as s
};
